import React from "react"; 
import { useNavigate } from "react-router-dom"; 
import sampleImage from "../Images/AboutUs.jpg"; 
const Hero = () => { 
  const navigate = useNavigate(); 
  return ( 
  <section className="flex flex-col md:flex-row items-center justify-between px-6 md:px-24 py-12"> {/* LEFT TEXT CONTENT */} 
  <div className="md:w-1/2 flex justify-center mt-8 px-4"> 
  <div className="text-center"> 
  <h2 className="text-3xl md:text-5xl leading-snug font-perandory text-[#9D2026]"> 
  CURATED TRAVEL THAT <br/>FEELS LIKE{' '} 
  <span className="font-sloop text-[#BA90A5] md:text-7xl text-5xl"> You</span> </h2> 
  <p className="text-base text-justify md:text-lg mt-6 text-gray-800 leading-relaxed font-belleza"> 
  At Aurah Leisure, travel is not merely a matter of logistics, it is a carefully curated experience that moves
   in harmony with your unique rhythm and aspirations. We believe that every journey should feel as effortless as
    it is enriching, blending meticulous planning with the art of personalization. With an unwavering commitment 
    to quality, elegance, and detail, we craft seamless itineraries that reflect sophistication, comfort, and the 
    spirit of true exploration. </p> 
  <button onClick={()=> navigate("/about-us")} 
  className="mt-4 font-garet font-semibold text-[14.5px] border-[#605C86] border-2 text-[#605C86] py-1 px-3 rounded-sm hover:bg-[#605C86] hover:text-[#D4AF37] transition"> 
  ABOUT US </button> 
  </div> 
  </div> 
  {/* RIGHT IMAGE */} 
  <div className="w-full md:w-1/2 mt-10 md:mt-0 flex justify-center md:justify-end"> 
  <div className="relative"> {/* Background Box */} 
  <div className="absolute -left-6 -bottom-6 w-[95%] h-[97%] bg-[#74E1F4]/15 z-0"></div> 
  {/* Actual Image */} <img src={sampleImage} alt="Santorini" className="relative z-10 w-full max-w-xl h-auto object-cover" /> 
  </div> 
  </div> 
  </section> 
  ); 
}; 
export default Hero;